export const Platform = Object.freeze({
  IOS: 'ios',
  ANDROID: 'android',
  NONE: 'none',
})

export function detectPlatform() {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return Platform.NONE

  const ua = navigator.userAgent.toLowerCase()

  if (ua.includes('android')) return Platform.ANDROID
  if (ua.includes('iphone')) return Platform.IOS

  return Platform.NONE
}
